import React from 'react';
import { translate } from '../../../shared/translations';
import GooglePlayStore from '../../../assets/Google-Play.svg';
import AppleAppStore from '../../../assets/Apple-App-Store.svg';
import AppetizeBackground from '../../../assets/ONE-bg.svg';
import LinkImage from '../../../components/LinkImage/LinkImage';
import Logo from '../../../components/Logo/Logo';
import { AMP } from '../../../constants/constants';
import { Subhead1, Link } from '../../../shared/theme/styles';
import './Appetize.css';

export const Appetize = ({ appConfig }) => {
    const {
        translateHeader = '',
        headerIcon = null,
        headIconAlt = '',
        google = '',
        ios = '',
        translatedLinkText = '',
        appToUse = '',
        iconClassname = '',
    } = appConfig;

    return (
        <div className="appetizePanel loginFormPanel">
            <Logo className={`${appToUse === AMP ? 'ampBackground' : 'movistaBackground'}`} url={AppetizeBackground} alt="movista-background" />
            <div className="loginContentWrapper">
                <div className="panelContent" style={Subhead1}>
                    <Logo className={iconClassname} url={headerIcon} alt={headIconAlt} />
                    {translate(translateHeader)}
                </div>
                <div className="panelContent">
                    <LinkImage
                        linkName="GooglePlayStore"
                        link={google}
                        image={GooglePlayStore}
                    />
                    <LinkImage
                        linkName="AppleAppStore"
                        link={ios}
                        image={AppleAppStore}
                    />
                </div>
                <a id="appetizeLink" style={Link} className="hyperlink-label panelContent panelLink" href={`/rep/mobile?app=${appToUse}`}>
                    {translate(translatedLinkText) }
                </a>
            </div>
        </div>
    );
};

export default Appetize;
